export default {
  create_title: 'Dodaj punkt końcowy webhooka',
  edit_title: 'Edytuj punkt końcowy webhooka',
  form: {
    url: 'Adres URL punktu końcowego HTTPS',
    description: 'Opis',
    description_placeholder: 'np. Zdarzenia zamówień dla POS',
    events: 'Zdarzenia do dostarczenia',
    events_required: 'Wybierz co najmniej jedno zdarzenie.',
    events_hint: 'Tylko wybrane zdarzenia są wysyłane do tego punktu końcowego.',
    events_selected: '{{selected}} z {{total}}',
    event_groups: {
      order: 'Zamówienia',
      store: 'Sklep',
      product: 'Produkty',
      modifier: 'Modyfikatory',
      menu_push: 'Wysyłki menu',
      payout: 'Wypłaty',
    },
    status: 'Status',
    status_active: 'Aktywny',
    status_disabled: 'Wyłączony',
    status_auto_disabled: 'Automatycznie wyłączony (wybierz Aktywny, aby ponownie włączyć)',
  },
  buttons: {
    cancel: 'Anuluj',
    create: 'Utwórz',
    save: 'Zapisz',
  },
  toasts: {
    created: 'Punkt końcowy utworzony.',
    updated: 'Punkt końcowy zaktualizowany.',
    error: 'Nie udało się zapisać punktu końcowego. Spróbuj ponownie.',
  },
};
